import type { SelectedValues } from '@vp/swan'
import { FlexBox, SelectionSet, SelectionSetInput, SelectionSetLabel, SelectionSetTileContents, SelectionSetTileName, Typography } from '@vp/swan'
import { useTranslation } from 'react-i18next'
import { OrderItemTile } from './order-item-tile'
import { mergeSelections } from '../../../../utils/order-selection.utils'
import type { FulfillmentItem } from '@shared/types/fulfillment-history.types'
import type { Order } from '@shared/types/order.types'
import { ProductImage } from '@shared/ui/product-image'

interface Props {
  order: Order
  selected: string[]
  onChange: (selectedIds: string[]) => void
  fulfillmentData: Map<string, FulfillmentItem[]>
  locale: string
}
export const OrderGroup = ({ order, selected, onChange, fulfillmentData, locale }: Props) => {
  const { t } = useTranslation()

  const orderItemIds = order.orderData.lineItems.map((i) => i.id)

  const selectedValues = Object.fromEntries(orderItemIds.map((id) => [id, selected.includes(id)]))

  const handleChange = (values: SelectedValues) => {
    const next = mergeSelections(values, selected, orderItemIds)
    onChange(next)
  }

  return (
    <FlexBox flexDirection="column" gap={3}>
      <Typography fontSkin="body-small" textColor="subtle" mt={3}>
        {t('contact_us.page.steps.issue_description.order_number', {
          orderNumber: order.orderNumber,
        })}
      </Typography>

      <SelectionSet skin="tiles-horizontal" variant="multi-select" selectedValues={selectedValues} onSelectedValuesChange={handleChange}>
        {order.orderData.lineItems.map((item) => (
          <SelectionSetInput key={item.id} value={item.id}>
            <SelectionSetLabel>
              <ProductImage item={item} />
              <SelectionSetTileContents>
                <SelectionSetTileName fontSkin="title-item">{item.productName}</SelectionSetTileName>

                <OrderItemTile order={order} fulfillment={fulfillmentData.get(item.id)?.[0]} locale={locale} />
              </SelectionSetTileContents>
            </SelectionSetLabel>
          </SelectionSetInput>
        ))}
      </SelectionSet>
    </FlexBox>
  )
}
